/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Building_TypeInputs */

const cs_form_building_type = /** @type {(inputs: Form_Building_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ stavby`)
};

const en_form_building_type = /** @type {(inputs: Form_Building_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building type`)
};

/**
* | output |
* | --- |
* | "Building type" |
*
* @param {Form_Building_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_building_type = /** @type {((inputs?: Form_Building_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Building_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_building_type(inputs)
	return cs_form_building_type(inputs)
});